<template>
  <BaseAction>
    <div class="d-flex justify-center approve-offer">
      <SecondaryButton
        @click.native="handleSubmit"
        color="primary"
        :disabled="isLoading"
      >
        <v-icon>
          mdi-thumb-up-outline
        </v-icon>
        Approve Document
      </SecondaryButton>
    </div>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import { createNamespacedHelpers } from "vuex";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import { APPROVE_DOCUMENT } from "@/store/modules/offers/actions";

const { mapActions } = createNamespacedHelpers(OFFERS_NAMESPACE);

export default {
  name: "ApproveDocumentAction",
  components: {
    SecondaryButton,
    BaseAction
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    currentOfferId() {
      return this.$route.params.id;
    },
    currentDocumentId() {
      return this.$route.params.documentId;
    }
  },
  methods: {
    ...mapActions({
      approveDocument: APPROVE_DOCUMENT
    }),
    async handleSubmit() {
      this.isLoading = true;
      await this.approveDocument({
        offerId: this.currentOfferId,
        documentId: this.currentDocumentId
      });
      this.isLoading = false;
    }
  }
};
</script>
<style lang="scss"></style>
